export default "__VITE_ASSET__16cd6bef__$_?nuxt_component=async__"